// 🚨 Auto-generated flat list of all images. Do not edit manually.

export const allImages = [
  {
    folder: 'blogImages',
    name: '5BenefitsOfCeramicCoatingsInfographic',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488932/mad-web-app/blog-images/5-benefits-of-ceramic-coatings-infographic.webp',
    publicId:
      'mad-web-app/blog-images/5-benefits-of-ceramic-coatings-infographic',
    alt: '5 Benefits Of Ceramic Coatings Infographic Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'winterCarDetailing10EssentialTips',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488931/mad-web-app/blog-images/winter-car-detailing-10-essential-tips.webp',
    publicId: 'mad-web-app/blog-images/winter-car-detailing-10-essential-tips',
    alt: 'Winter Car Detailing 10 Essential Tips Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'getYourCarReadyForFallEssentialTipsFromMayesAutoDetailing',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488931/mad-web-app/blog-images/get-your-car-ready-for-fall-essential-tips-from-mayes-auto-detailing.webp',
    publicId:
      'mad-web-app/blog-images/get-your-car-ready-for-fall-essential-tips-from-mayes-auto-detailing',
    alt: 'Get Your Car Ready For Fall Essential Tips From {business.name} Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'totalInteriorShampoo{business.address.city}',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488930/mad-web-app/blog-images/total-interior-shampoo-{business.address.city}.jpg',
    publicId:
      'mad-web-app/blog-images/total-interior-shampoo-{business.address.city}',
    alt: 'Total Interior Shampoo {business.address.city} Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'whyVehicleTintingIsAGreatInvestmentInYourCar',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488929/mad-web-app/blog-images/why-vehicle-tinting-is-a-great-investment-in-your-car.webp',
    publicId:
      'mad-web-app/blog-images/why-vehicle-tinting-is-a-great-investment-in-your-car',
    alt: 'Why Vehicle Tinting Is A Great Investment In Your Car Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'autoDetailingHowOftenShouldIDeepCleanMyCar',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488928/mad-web-app/blog-images/auto-detailing-how-often-should-i-deep-clean-my-car.webp',
    publicId:
      'mad-web-app/blog-images/auto-detailing-how-often-should-i-deep-clean-my-car',
    alt: 'Auto Detailing How Often Should I Deep Clean My Car Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'choosingTheRightCarDetailer',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488927/mad-web-app/blog-images/choosing-the-right-car-detailer.jpg',
    publicId: 'mad-web-app/blog-images/choosing-the-right-car-detailer',
    alt: 'Choosing The Right Car Detailer Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'welcomingSolarfxWindowFilm',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488926/mad-web-app/blog-images/welcoming-solarfx-window-film.webp',
    publicId: 'mad-web-app/blog-images/welcoming-solarfx-window-film',
    alt: 'Welcoming Solarfx Window Film Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'unveilingTheBrillianceWhatIsCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488925/mad-web-app/blog-images/unveiling-the-brilliance-what-is-ceramic-coating.webp',
    publicId:
      'mad-web-app/blog-images/unveiling-the-brilliance-what-is-ceramic-coating',
    alt: 'Unveiling The Brilliance What Is Ceramic Coating Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'ourNewWebsiteIsLive',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488924/mad-web-app/blog-images/our-new-website-is-live.webp',
    publicId: 'mad-web-app/blog-images/our-new-website-is-live',
    alt: 'Our New Website Is Live Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'welcomingTeslaTo{business.address.city}',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488923/mad-web-app/blog-images/welcoming-tesla-to-{business.address.city}.webp',
    publicId:
      'mad-web-app/blog-images/welcoming-tesla-to-{business.address.city}',
    alt: 'Welcoming Tesla To {business.address.city} Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'windowTintAndElectricVehiclesWhatYouShouldKnow',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488922/mad-web-app/blog-images/window-tint-and-electric-vehicles-what-you-should-know.webp',
    publicId:
      'mad-web-app/blog-images/window-tint-and-electric-vehicles-what-you-should-know',
    alt: 'Window Tint And Electric Vehicles What You Should Know Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'carInterior10TipsForEffortlessMaintenance',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488921/mad-web-app/blog-images/car-interior-10-tips-for-effortless-maintenance.webp',
    publicId:
      'mad-web-app/blog-images/car-interior-10-tips-for-effortless-maintenance',
    alt: 'Car Interior 10 Tips For Effortless Maintenance Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'springCarPrepGuide',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488921/mad-web-app/blog-images/spring-car-prep-guide.webp',
    publicId: 'mad-web-app/blog-images/spring-car-prep-guide',
    alt: 'Spring Car Prep Guide Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'whyDoINeedCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488920/mad-web-app/blog-images/why-do-i-need-ceramic-coating.webp',
    publicId: 'mad-web-app/blog-images/why-do-i-need-ceramic-coating',
    alt: 'Why Do I Need Ceramic Coating Blog Image',
  },
  {
    folder: 'blogImages',
    name: 'theEmbassyCarCareGiftCardsThePerfectGiftForAnyOccasion',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488919/mad-web-app/blog-images/the-embassy-car-care-gift-cards-the-perfect-gift-for-any-occasion.webp',
    publicId:
      'mad-web-app/blog-images/the-embassy-car-care-gift-cards-the-perfect-gift-for-any-occasion',
    alt: 'The Embassy Car Care Gift Cards The Perfect Gift For Any Occasion Blog Image',
  },
  {
    folder: 'logoImages',
    name: 'appleTouchIcon',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744314821/mad-web-app/logo-images/apple-touch-icon.png',
    publicId: 'mad-web-app/logo-images/apple-touch-icon',
    alt: 'Apple Touch Icon Logo Image',
  },
  {
    folder: 'fotoImages',
    name: 'customerSatisfaction',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742386332/mad-web-app/foto-images/customer-satisfaction.png',
    publicId: 'mad-web-app/foto-images/customer-satisfaction',
    alt: 'Customer Satisfaction Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage12',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742018126/mad-web-app/foto-images/foto-image-12.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-12',
    alt: 'Foto Image 12 Foto Image',
  },
  {
    folder: 'servImages',
    name: 'madEliteFullDetail',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742017562/mad-web-app/serv-images/mad-elite-full-detail.jpg',
    publicId: 'mad-web-app/serv-images/mad-elite-full-detail',
    alt: 'Mad Elite Full Detail Serv Image',
  },
  {
    folder: 'servImages',
    name: 'madEliteCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742011879/mad-web-app/serv-images/mad-elite-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-elite-ceramic-coating',
    alt: 'Mad Elite Ceramic Coating Serv Image',
  },
  {
    folder: 'logoImages',
    name: 'madBadge',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741893335/mad-web-app/logo-images/mad-badge.png',
    publicId: 'mad-web-app/logo-images/mad-badge',
    alt: 'Mad Badge Logo Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage11',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741892429/mad-web-app/foto-images/foto-image-11.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-11',
    alt: 'Foto Image 11 Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage10',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741892234/mad-web-app/foto-images/foto-image-10.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-10',
    alt: 'Foto Image 10 Foto Image',
  },
  {
    folder: 'logoImages',
    name: 'solarFx',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741887881/mad-web-app/logo-images/solar-fx.png',
    publicId: 'mad-web-app/logo-images/solar-fx',
    alt: 'Solar Fx Logo Image',
  },
  {
    folder: 'servImages',
    name: 'madSignatureMfCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741884814/mad-web-app/serv-images/mad-signature-mf-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-signature-mf-ceramic-coating',
    alt: 'Mad Signature Mf Ceramic Coating Serv Image',
  },
  {
    folder: 'servImages',
    name: 'madClassicCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741884086/mad-web-app/serv-images/mad-classic-ceramic-coating.jpg',
    publicId: 'mad-web-app/serv-images/mad-classic-ceramic-coating',
    alt: 'Mad Classic Ceramic Coating Serv Image',
  },
  {
    folder: 'heroImages',
    name: 'paintCorrection',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741883598/mad-web-app/hero-images/paint-correction.jpg',
    publicId: 'mad-web-app/hero-images/paint-correction',
    alt: 'Paint Correction Hero Image',
  },
  {
    folder: 'logoImages',
    name: 'madGoogleBadge',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741883235/mad-web-app/logo-images/mad-google-badge.png',
    publicId: 'mad-web-app/logo-images/mad-google-badge',
    alt: 'Mad Google Badge Logo Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage09',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741882721/mad-web-app/foto-images/foto-image-09.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-09',
    alt: 'Foto Image 09 Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage08',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741882515/mad-web-app/foto-images/foto-image-08.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-08',
    alt: 'Foto Image 08 Foto Image',
  },
  {
    folder: 'servImages',
    name: 'madDeluxeFullDetail',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881865/mad-web-app/serv-images/mad-deluxe-full-detail.jpg',
    publicId: 'mad-web-app/serv-images/mad-deluxe-full-detail',
    alt: 'Mad Deluxe Full Detail Serv Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage07',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881449/mad-web-app/foto-images/foto-image-07.heic',
    publicId: 'mad-web-app/foto-images/foto-image-07',
    alt: 'Foto Image 07 Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage06',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881272/mad-web-app/foto-images/foto-image-06.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-06',
    alt: 'Foto Image 06 Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage13',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880639/mad-web-app/foto-images/foto-image-13.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-13',
    alt: 'Foto Image 13 Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage05',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880520/mad-web-app/foto-images/foto-image-05.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-05',
    alt: 'Foto Image 05 Foto Image',
  },
  {
    folder: 'heroImages',
    name: 'homePage',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880412/mad-web-app/hero-images/home-page.webp',
    publicId: 'mad-web-app/hero-images/home-page',
    alt: 'Home Page Hero Image',
  },
  {
    folder: 'cityImages',
    name: 'soddyDaisy',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265515/mad-web-app/city-images/soddy-daisy.jpg',
    publicId: 'mad-web-app/city-images/soddy-daisy',
    alt: 'Soddy Daisy City Image',
  },
  {
    folder: 'cityImages',
    name: 'redBank',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265318/mad-web-app/city-images/red-bank.jpg',
    publicId: 'mad-web-app/city-images/red-bank',
    alt: 'Red Bank City Image',
  },
  {
    folder: 'cityImages',
    name: 'ooltewah',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265250/mad-web-app/city-images/ooltewah.jpg',
    publicId: 'mad-web-app/city-images/ooltewah',
    alt: 'Ooltewah City Image',
  },
  {
    folder: 'cityImages',
    name: 'bannerLogo',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741236002/mad-web-app/city-images/banner-logo.png',
    publicId: 'mad-web-app/city-images/banner-logo',
    alt: 'Banner Logo City Image',
  },
  {
    folder: 'cityImages',
    name: 'collegedale',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741225113/mad-web-app/city-images/collegedale.jpg',
    publicId: 'mad-web-app/city-images/collegedale',
    alt: 'Collegedale City Image',
  },
  {
    folder: 'cityImages',
    name: 'cleveland',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741224457/mad-web-app/city-images/cleveland.jpg',
    publicId: 'mad-web-app/city-images/cleveland',
    alt: 'Cleveland City Image',
  },
  {
    folder: 'cityImages',
    name: 'eastRidge',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741223396/mad-web-app/city-images/east-ridge.jpg',
    publicId: 'mad-web-app/city-images/east-ridge',
    alt: 'East Ridge City Image',
  },
  {
    folder: 'cityImages',
    name: '{business.address.city}',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741182895/mad-web-app/city-images/{business.address.city}.jpg',
    publicId: 'mad-web-app/city-images/{business.address.city}',
    alt: '{business.address.city} City Image',
  },
  {
    folder: 'heroImages',
    name: 'giftCards',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741010439/mad-web-app/hero-images/gift-cards.png',
    publicId: 'mad-web-app/hero-images/gift-cards',
    alt: 'Gift Cards Hero Image',
  },
  {
    folder: 'heroImages',
    name: 'blogs',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741009279/mad-web-app/hero-images/blogs.webp',
    publicId: 'mad-web-app/hero-images/blogs',
    alt: 'Blogs Hero Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage04',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740961731/mad-web-app/foto-images/foto-image-04.webp',
    publicId: 'mad-web-app/foto-images/foto-image-04',
    alt: 'Foto Image 04 Foto Image',
  },
  {
    folder: 'heroImages',
    name: 'booking',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740951149/mad-web-app/hero-images/booking.webp',
    publicId: 'mad-web-app/hero-images/booking',
    alt: 'Booking Hero Image',
  },
  {
    folder: 'logoImages',
    name: 'systemXAuthorizedInstaller',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740581207/mad-web-app/logo-images/system-x-authorized-installer.png',
    publicId: 'mad-web-app/logo-images/system-x-authorized-installer',
    alt: 'System X Authorized Installer Logo Image',
  },
  {
    folder: 'fotoImages',
    name: 'after',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740576226/mad-web-app/foto-images/after.jpg',
    publicId: 'mad-web-app/foto-images/after',
    alt: 'After Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'before',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740576207/mad-web-app/foto-images/before.jpg',
    publicId: 'mad-web-app/foto-images/before',
    alt: 'Before Foto Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage03',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740574552/mad-web-app/foto-images/foto-image-03.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-03',
    alt: 'Foto Image 03 Foto Image',
  },
  {
    folder: 'servImages',
    name: 'totalInteriorDetail',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740550080/mad-web-app/serv-images/total-interior-detail.webp',
    publicId: 'mad-web-app/serv-images/total-interior-detail',
    alt: 'Total Interior Detail Serv Image',
  },
  {
    folder: 'servImages',
    name: 'fullInteriorDetail',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549852/mad-web-app/serv-images/full-interior-detail.jpg',
    publicId: 'mad-web-app/serv-images/full-interior-detail',
    alt: 'Full Interior Detail Serv Image',
  },
  {
    folder: 'servImages',
    name: 'exteriorClayPolish',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549480/mad-web-app/serv-images/exterior-clay-polish.jpg',
    publicId: 'mad-web-app/serv-images/exterior-clay-polish',
    alt: 'Exterior Clay Polish Serv Image',
  },
  {
    folder: 'servImages',
    name: 'exteriorDeconProtect',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549210/mad-web-app/serv-images/exterior-decon-protect.jpg',
    publicId: 'mad-web-app/serv-images/exterior-decon-protect',
    alt: 'Exterior Decon Protect Serv Image',
  },
  {
    folder: 'servImages',
    name: 'exteriorWashProtect',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740548908/mad-web-app/serv-images/exterior-wash-protect.webp',
    publicId: 'mad-web-app/serv-images/exterior-wash-protect',
    alt: 'Exterior Wash Protect Serv Image',
  },
  {
    folder: 'servImages',
    name: 'madEssentialsFullDetail',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740531909/mad-web-app/serv-images/mad-essentials-full-detail.jpg',
    publicId: 'mad-web-app/serv-images/mad-essentials-full-detail',
    alt: 'Mad Essentials Full Detail Serv Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage02',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740531440/mad-web-app/foto-images/foto-image-02.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-02',
    alt: 'Foto Image 02 Foto Image',
  },
  {
    folder: 'heroImages',
    name: 'windowTinting',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739935565/mad-web-app/hero-images/window-tinting.webp',
    publicId: 'mad-web-app/hero-images/window-tinting',
    alt: 'Window Tinting Hero Image',
  },
  {
    folder: 'servImages',
    name: 'fullWindowTint',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931043/mad-web-app/serv-images/full-window-tint.png',
    publicId: 'mad-web-app/serv-images/full-window-tint',
    alt: 'Full Window Tint Serv Image',
  },
  {
    folder: 'servImages',
    name: 'standardWindowTint',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931028/mad-web-app/serv-images/standard-window-tint.png',
    publicId: 'mad-web-app/serv-images/standard-window-tint',
    alt: 'Standard Window Tint Serv Image',
  },
  {
    folder: 'servImages',
    name: 'windshieldTint',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931015/mad-web-app/serv-images/windshield-tint.png',
    publicId: 'mad-web-app/serv-images/windshield-tint',
    alt: 'Windshield Tint Serv Image',
  },
  {
    folder: 'servImages',
    name: 'front2Windows',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931004/mad-web-app/serv-images/front-2-windows.png',
    publicId: 'mad-web-app/serv-images/front-2-windows',
    alt: 'Front 2 Windows Serv Image',
  },
  {
    folder: 'servImages',
    name: 'windshieldStrip',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739930970/mad-web-app/serv-images/windshield-strip.png',
    publicId: 'mad-web-app/serv-images/windshield-strip',
    alt: 'Windshield Strip Serv Image',
  },
  {
    folder: 'heroImages',
    name: 'contactUs',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739764510/mad-web-app/hero-images/contact-us.jpg',
    publicId: 'mad-web-app/hero-images/contact-us',
    alt: 'Contact Us Hero Image',
  },
  {
    folder: 'heroImages',
    name: 'allServices',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739764111/mad-web-app/hero-images/all-services.jpg',
    publicId: 'mad-web-app/hero-images/all-services',
    alt: 'All Services Hero Image',
  },
  {
    folder: 'servImages',
    name: 'windowTint',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739417470/mad-web-app/serv-images/window-tint.webp',
    publicId: 'mad-web-app/serv-images/window-tint',
    alt: 'Window Tint Serv Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage01',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739412349/mad-web-app/foto-images/foto-image-01.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-01',
    alt: 'Foto Image 01 Foto Image',
  },
  {
    folder: 'servImages',
    name: 'madSignatureCeramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739373593/mad-web-app/serv-images/mad-signature-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-signature-ceramic-coating',
    alt: 'Mad Signature Ceramic Coating Serv Image',
  },
  {
    folder: 'fotoImages',
    name: 'fotoImage14',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739367271/mad-web-app/foto-images/foto-image-14.webp',
    publicId: 'mad-web-app/foto-images/foto-image-14',
    alt: 'Foto Image 14 Foto Image',
  },
  {
    folder: 'heroImages',
    name: 'ceramicCoating',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739366697/mad-web-app/hero-images/ceramic-coating.jpg',
    publicId: 'mad-web-app/hero-images/ceramic-coating',
    alt: 'Ceramic Coating Hero Image',
  },
  {
    folder: 'fotoImages',
    name: 'davidMayes',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739301587/mad-web-app/foto-images/david-mayes.jpg',
    publicId: 'mad-web-app/foto-images/david-mayes',
    alt: 'David Mayes Foto Image',
  },
  {
    folder: 'logoImages',
    name: 'favicon',
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1735430114/mad-web-app/logo-images/favicon.png',
    publicId: 'mad-web-app/logo-images/favicon',
    alt: 'Favicon Logo Image',
  },
];
